import React, { FC } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { WithdrawCryptoFormFields } from 'modules/payments/hooks/use-withdraw-crypto-form';
import { Box, Typography } from '@mui/material';
import { TextInput } from 'shared/components/Form/TextInput';
import { ErrorMessage } from 'shared/components/Form/ErrorMessage';

interface WithdrawCryptoProviderFormProps {
  form: UseFormReturn<WithdrawCryptoFormFields>;
  isDisabled: boolean;
}

export const WithdrawCryptoProviderForm: FC<WithdrawCryptoProviderFormProps> = ({
  form,
  isDisabled,
}) => {
  const {
    control,
    formState: { errors },
  } = form;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
          <Typography mb={1}>Withdraw address:</Typography>

          <Controller
            control={control}
            name="destinationAddress"
            render={({ field: { onChange, value, ...rest } }) => (
              <TextInput
                placeholder="E.g. 0xc980bded5a13887a54dfaae7bf80a29b07df2362"
                onChange={onChange}
                value={value}
                disabled={isDisabled}
                {...rest}
              />
            )}
          />
        </Box>
      </Box>
      <Box>
        {errors.destinationAddress?.message && (
          <ErrorMessage error={errors.destinationAddress.message} withSidePadding={false} />
        )}
      </Box>
    </Box>
  );
};
